import api from './api';

export const getShortsData = (page, params) => {
  return api.get('admin/Short', { params: { page: page, limit: 10, order: 'createdAt', direction: 'DESC', ...params } });
};
export const updateShort = (shortId, update) => {
  return api.put(`admin/Short/item/${shortId}`, { object: update });
};

export const editShort = (id, data) => {
  return api.put(`short/${id}`, data);
};
